module.exports = __webpack_public_path__ + "img/contact_header.8543a0c6.png";